(() => {
  const markerKey = 'neuloEnglishGate';
  let markedAt = 0;
  try { markedAt = Number(sessionStorage.getItem(markerKey) || 0); } catch (error) {}
  const isEnglish = document.documentElement.lang.toLowerCase().startsWith('en');
  const requestsEnglishGate = new URLSearchParams(location.search).get('gate_locale') === 'en';
  const followsEnglishRedirect = markedAt > 0 && Date.now() - markedAt < 20000;
  if (!isEnglish && !followsEnglishRedirect && !requestsEnglishGate) return;
  let translated = false;
  const text = new Map([
    ['パスワードを入力', 'Enter your password'],
    ['PathOne 限定購入ページ', 'Private PathOne purchase page'],
    ['ご案内メールに記載されたパスワードを入力し、「進む」を押してください。', 'Enter the password from your invitation email, then select Continue.'],
    ['パスワード', 'Password'],
    ['進む', 'Continue'],
    ['パスワードを入力してください。', 'Please enter your password.'],
    ['パスワードが違います。ご案内メールをご確認ください。', 'Incorrect password. Please check your invitation email.']
  ]);
  const attributes = new Map([
    ['パスワードを入力', 'Enter your password'],
    ['パスワード', 'Password']
  ]);
  const translate = (root) => {
    if (root.nodeType === Node.TEXT_NODE) {
      const source = root.nodeValue.trim();
      if (text.has(source)) { root.nodeValue = root.nodeValue.replace(source, text.get(source)); translated = true; }
      return;
    }
    if (!(root instanceof Element || root instanceof Document)) return;
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    while (walker.nextNode()) translate(walker.currentNode);
    root.querySelectorAll?.('[placeholder],[aria-label]').forEach((element) => {
      ['placeholder', 'aria-label'].forEach((name) => {
        const source = element.getAttribute(name);
        if (attributes.has(source)) { element.setAttribute(name, attributes.get(source)); translated = true; }
      });
    });
  };
  const start = () => {
    translate(document);
    if (translated) { try { sessionStorage.removeItem(markerKey); } catch (error) {} }
    const observer = new MutationObserver((mutations) => mutations.forEach((mutation) => {
      mutation.addedNodes.forEach(translate);
      if (mutation.type === 'characterData') translate(mutation.target);
    }));
    if (translated) { try { sessionStorage.removeItem(markerKey); } catch (error) {} }
    observer.observe(document.body, { childList: true, subtree: true, characterData: true });
    setTimeout(() => { try { sessionStorage.removeItem(markerKey); } catch (error) {} }, 20000);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
